import api from "../../../utils/api";

export function fetchCountryLocationsData({ fetchUrl }) {
    this.sliderReady = false;
    this.noResults = false;
    try {
        api(fetchUrl)
            .then((response: any) => {
                if (response.location.length === 0) {
                    this.noResults = true;
                }
                this.apiResponse = response;
            })
            .catch(() => {
                this.error = true;
            });
    } catch {
        this.error = true;
    }
}
